import { Search, X } from "lucide-react";

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  id?: string;
  placeholder?: string;
}

// Controlled text search box that filters results instantly as the user types,
// with a quick clear button so backspacing isn't required.
export default function SearchInput({
  value,
  onChange,
  label,
  id,
  placeholder = "Search...",
}: SearchInputProps) {
  return (
    <fieldset className="border-t border-gray-200 pt-6 dark:border-gray-700">
      <legend className="sr-only">{label}</legend>
      <h3 className="text-md mb-2 flex items-center gap-2 font-bold text-gray-800 dark:text-gray-100">
        <Search
          className="h-4 w-4 text-blue-500 dark:text-blue-400"
          aria-hidden="true"
        />
        Search:
      </h3>
      <div className="relative">
        <label htmlFor={id} className="sr-only">
          {label}
        </label>
        <input
          id={id}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className="w-full rounded-lg border border-gray-300 bg-white py-2 pr-9 pl-3 text-gray-800 placeholder-gray-400 dark:border-gray-600 dark:bg-gray-700 dark:text-gray-100 dark:placeholder-gray-500"
        />
        {value && (
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute top-1/2 right-2 -translate-y-1/2 rounded-full p-1 text-gray-400 hover:bg-gray-200 hover:text-gray-600 dark:hover:bg-gray-600 dark:hover:text-gray-300"
            aria-label="Clear search"
          >
            <X className="h-4 w-4" aria-hidden="true" />
          </button>
        )}
      </div>
    </fieldset>
  );
}
